import { useEffect, useState } from "react";

import type { File, FilesAPIResponse } from "./types";
import useFetchTax from "./use-fetch-tax";

export default function useMeFiles() {
  const [files, setFiles] = useState<File[] | null>(null);

  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const {
    isLoading: useFetchTaxIsLoading,
    error: useFetchTaxError,
    get,
  } = useFetchTax();

  useEffect(() => {
    const fetch = async () => {
      try {
        const files = (await get("me/files")) as FilesAPIResponse;
        setFiles(files.data);
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (!files && !isLoading && !useFetchTaxIsLoading && !error) {
      setIsLoading(true);
      fetch();
    }
  }, [files, isLoading, useFetchTaxIsLoading, error, get]);

  return {
    files: files,
    isLoading: isLoading || useFetchTaxIsLoading,
    error: error || useFetchTaxError,
  };
}
